import BlockSpinner from './BlockSpinner'

export default BlockSpinner
